module.exports = __webpack_public_path__ + "static/media/icon-4.ccd30ffd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/icon-4.png
// module id = 2563
// module chunks = 0